import { DateTime } from "luxon";

export enum ActionStatus {
  New = 111,
  AutoResolve = 222,
  Resolve = 223,
  Resolved = 333, // DONE
  DoNotEscalate = 444,
  Escalated = 555,
  Reminder = 666,
  ReminderSent = 777,
  Open = 888,
  InProgress = 889,
  Reject = 890,
  Approve = 891,
  Requested = 892,
  Cancelled = 999
}

export enum ActionType {
    Alert = 1,
    PurchaseRequisition = 2,
    ApplyEasy = 5,
    PurchaseOrder = 6,
    Audit = 999
  }

  export const ActionTypeDisplayNames: { [key in ActionType]: string } = {
    [ActionType.Alert]: 'Alert',
    [ActionType.PurchaseRequisition]: 'Purchase Requisition',
    [ActionType.ApplyEasy]: 'ApplyEasy',
    [ActionType.Audit]: 'Audit',
    [ActionType.PurchaseOrder]: 'Purchase Order',
  };
  
  // Optional: Function to get display name by ActionType
  export function getActionTypeDisplayName(actionType: ActionType): string {
    return ActionTypeDisplayNames[actionType];
  }
  
  export enum ActionAlertSubType {
    OutSideNotHire = 51,
    InSideOnHire = 52,
    OutSideStoodDownUsed = 53,
    OutSideOffHiredUsed = 54
  }
  
  export enum ActionPRSubType {
    PRRequest = 61,
    PRRequestSupplier = 62,
    SubHirePRRequest = 63,
  }
  
  export enum ActionPOSubType {
    PORequest = 81,
  }

  export enum ActionApplyEasySubType {
    BaseplanCustomerCreationFailure = 71,
  }

  export declare interface IActions {
    id: string;
    parentId: string;
    action_Id: string;
    actionTypeId: number;
    actionSubTypeId: number;
    actionTitle: string;
    branchId: number;
    siteId: number;
    companyId: number;
    hireNo: number;
    // utilisation: number|undefined;
    // occuredDateTime: DateTime;
    // subject: string;
    status: number;
    // siteName: string|undefined;
    // branchName: string|undefined;
    // companyName: string|undefined;
    additional: IAdditional|undefined;
    lineItems: ILineItem[];
    actionButton:	any;
    chats:	IChat[];
    hasChild: boolean;
    eta: DateTime;
    orderExpiryDate: DateTime;
    deliveryAddress: string;
    chatMsg: string;
}

export declare interface IAdditional {
  equipmentNo: string;
  contractNo: string;
  category: string;
  siteName: string|undefined;
  branchName: string|undefined;
  companyName: string|undefined;
  description: string;
  standDownReason: string;
  utilisation: string;
  status: number;
  occuredDateTime: DateTime;
  // geoLocation: IGeoLocation;
  latGeolocation: any|undefined;
  lonGeolocation: any|undefined;
  // equipments: IEquipment;
  supplier: ISupplier;
  approvers: IApprovers;
  requesterUser: IApprovers;
  totalAmount: number|undefined;
  // lineItems: ILineItem[];
  subTypes: ISublineType[] | undefined;
  quotes: IQuote[];
  singleSourcePurchaseDetails: ISingleSourceDetails[];
  isSingleSourcePurchase: boolean|undefined;
  customerId?: string;
  errorMessage?: string;
  applicationId?: string;
  referenceNumber?: string;
}

export declare interface ILineItem {
  id: string|undefined;
  name: string|undefined;
  description: string|undefined;
  unitPrice: number|undefined;
  qty: number|undefined;
  unitAmount: number|undefined;
  majorCode: number|undefined;
  minorCode: number|undefined;
  accountCode: string|undefined;
  sublineType: string|undefined;
  actionType: 'Approved' | 'Rejected' | 'Requested' | undefined;
  prevActionType: 'Approved' | 'Rejected' | 'Requested' | undefined;
  isContracted: boolean|undefined;
  origin: string|undefined;
}

export declare interface IQuote {
  fileName: string|undefined;
  isWinner: string|undefined;
  isValid: boolean|undefined;
  reason: string|undefined;
  uploadUrl: string|undefined;
}

export declare interface ISingleSourceDetails {
  ssaType: string|undefined;
  justification: string|undefined;
  files: ISingleSourceFile[]|undefined;
}

export declare interface ISingleSourceFile {
  fileName: string|undefined;
  uploadUrl: string|undefined;
}

export declare interface IChat {
  date: Date|undefined;
  requesterUserEmail	: string|undefined;
  requesterUserName	: string|undefined;
  approverUserEmail	: string|undefined;
  approverUserName	: string|undefined;
  message: string|undefined;
  fileName: string|undefined;
}
export declare interface IChatMsg {
  message: string|undefined;
  fileName: string|undefined;
}

export declare interface ISupplier {
  abn: string|undefined;
  name: string|undefined;
  creditorCode: string|undefined;
  address: string|undefined;
  contact: string|undefined;
  email: string|undefined;
  isApproved: boolean|undefined;
}

export declare interface IApprovers {
  userName: string|undefined;
  userEmail: string|undefined;
  type: string|undefined;
  isSSAApprover : boolean|undefined;
}

export declare interface ISublineType {
  sublineType: string|undefined;
  pO_Limit: number|undefined;
}